import axios from "axios";

import { TTP_API_URL } from "../config";

export const saveFaq = async (token, data) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-faq`;
  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("titleFr", data.titleFr);
  formData.append("titleEn", data.titleEn);
  formData.append("titleNl", data.titleNl);
  formData.append("descriptionFr", data.descriptionFr);
  formData.append("descriptionEn", data.descriptionEn);
  formData.append("descriptionNl", data.descriptionNl);
  formData.append("organization", data.organization);

  if (data.id) {
    formData.append("id", data.id);
  }
  return await axios.post(requestUrl, formData);
};

export const getFaqs = (token, organization) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-faq`;
  const serviceFilter = [];
  if (organization) {
    serviceFilter.push({
      property: "organization",
      value: organization,
      operator: "eq",
    });
  }
  const sort = [
    {
      property: "updatedAt",
      dir: "desc",
    },
  ];
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(serviceFilter),
      sort: JSON.stringify(sort),
    },
  });
};

export const deleteFaq = (token, id) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-faq/${id}`;
  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");

  return axios.post(requestUrl, formData);
};
